module.exports = __webpack_public_path__ + "e842bcc06e4267a9dc489437e1fa48e1.jpg";